class registerDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#registerDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.querySelector('#loginButton').addEventListener('click', this.toggleLogin.bind(this));
    new URL(window.location.href).searchParams.get("registerDrawer") && this.open();
  }

  setHeaderCartIconAccessibility() {
    const registerLink = document.querySelector('#register-drawer-bubble');
    registerLink.setAttribute('role', 'button');
    registerLink.setAttribute('aria-haspopup', 'dialog');
    registerLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(registerLink)
    });
    registerLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(registerLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = document.getElementById('registerDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.register__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('register-open');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('register-open');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  toggleLogin(){
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('register-open');

    document.querySelector('#login-drawer-bubble').click();
  }
}

customElements.define('register-drawer', registerDrawer);